import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";

export const DocumentationPageDependencies = z.object({
  id: z.string(),
  designSystemVersionId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  documentationPageId: z.string(),

  tokenPersistentIds: z.set(z.string()),
  figmaComponentPersistentIds: z.set(z.string()),
  componentPersistentIds: z.set(z.string()),
  figmaNodePersistentIds: z.set(z.string()),
  groupPersistentIds: z.set(z.string()),
  propertyPersistentIds: z.set(z.string()),
  themePersistentIds: z.set(z.string()),
  documentationPagePersistentIds: z.set(z.string()),
  storybookEntriesStoryIds: z.array(z.string()),
});

export type PageContentDependencies = {
  tokenPersistentIds: Set<string>;
  figmaComponentPersistentIds: Set<string>;
  componentPersistentIds: Set<string>;
  figmaNodePersistentIds: Set<string>;
  groupPersistentIds: Set<string>;
  propertyPersistentIds: Set<string>;
  themePersistentIds: Set<string>;
  documentationPagePersistentIds: Set<string>;
  storybookEntriesStoryIds: Array<string>;
};
export type PagesContentDependencies = Map<string, PageContentDependencies>;

export type DocumentationPageDependencies = z.infer<typeof DocumentationPageDependencies>;

export type CreateDocumentationPageDependencies = DbCreateInputOmit<DocumentationPageDependencies>;
export type UpdateDocumentationPageDependencies = OmitStrict<
  DbUpdate<DocumentationPageDependencies>,
  "designSystemVersionId" | "documentationPageId"
>;
